import { useNavigate } from "react-router-dom";
import { createExportButton } from "../../Grid/ExcelExport/CreateExportButton";
import SingleSelectKendoGrid from "../../Grid/Selectable/SingleSelectKendoGrid";
import { defaultAddButton } from "../../Grid/Toolbar/DefaultAddButton";
import { defaultEditButton } from "../../Grid/Toolbar/DefaultEditButton";
import PageHeader from "../../Layout/Header/PageHeader";
import { supplierUrls } from "../../URL/ApplicationUrls";
import { combinedUrls } from "../../URL/functions";
import SupplierGridColumns from "./SupplierGridColumns";
import { SupplierOverviewItem } from "./SupplierOverviewItem";
import { AuthorizationPolicies } from "../../Auth/AuthorizationPolicy";
import { formatDateForFilename } from "../../Utils/dates";

function SupplierOverview() {
  const navigate = useNavigate();

  const addSupplier = () => navigate(supplierUrls.addSupplier.uiPath);

  const editSupplier = (supplier: SupplierOverviewItem | undefined) =>
    supplier && navigate(supplierUrls.supplierWithId(supplier.Id).uiPath);

  const url = combinedUrls(supplierUrls.base.apiUrl, "KendoGrid");

  return (
    <>
      <PageHeader headerText="Supplier" />
      <SingleSelectKendoGrid
        localStorageKey="SupplierOverviewGrid_DataState"
        fetchUrl={url}
        columns={SupplierGridColumns()}
        idSelector={(supplier: SupplierOverviewItem) => supplier.Id}
        toolbarItems={[
          defaultAddButton({
            onClick: addSupplier,
            roles: AuthorizationPolicies.RequireAdminNetworkLaunchRoles,
          }),
          defaultEditButton({
            onClick: editSupplier,
            roles: AuthorizationPolicies.RequireAdminNetworkLaunchRoles,
          }),
        ]}
        onRowDoubleClick={editSupplier}
        customToolbarItems={[
          createExportButton({ url, filename: `Supplier_${formatDateForFilename()}` }),
        ]}
      />
    </>
  );
}

export default SupplierOverview;
